<template>
  <div class="manage-users-page">
    <PageHeader :title="$t('manageUsers.title')"/>
    <PageContainer size="small">
      <el-button
        type="primary"
        icon="el-icon-add"
        @click="showAddUserDialog">
        {{ $t('manageUsers.addUserButtonText') }}
      </el-button>
      <AddUserDialog
        v-if="displayAddUserDialog"
        @close="hideAddUserDialog"
        @onUserAdded="handleUserAdded"/>
      <div style="margin-top: 40px;"></div>
      <UsersTable :tableData="users" v-loading="loading"/>
    </PageContainer>
  </div>
</template>
<script>
import services from 'services';
import PageHeader from '@/components/PageHeader/PageHeader.vue';
import PageContainer from '@/components/PageContainer/PageContainer.vue';
import UsersTable from './UsersTable.vue';
import AddUserDialog from './AddUserDialog.vue';

export default {
  components: {
    PageHeader,
    PageContainer,
    UsersTable,
    AddUserDialog,
  },
  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      users: [],
      displayAddUserDialog: false,
    };
  },
  methods: {
    async fetchData() {
      this.users = await services.shopAuthService.listAllUsers();
    },
    showAddUserDialog() {
      this.displayAddUserDialog = true;
    },
    hideAddUserDialog() {
      this.displayAddUserDialog = false;
    },
    handleUserAdded(user) {
      this.users.push(user);
    },
  },
};
</script>
<style lang="stylus" scoped>
.manage-users-page {
  width: 100%;
}
</style>
